import React, { memo } from "react"
import styled from "@emotion/styled"
import { breakpoints, color } from "../../utils/style"
import GetWindowWidth from "../shared/GetWindowWidth"

const ContactBlockWrap = styled("div")`
  border: 1px solid ${color.gold};
  box-sizing: border-box;
  filter: drop-shadow(0px 0px 48px rgba(196, 129, 0, 0.8));
  border-radius: 8px;
  padding: 12px 32px;
  text-align: center;
  text-transform: uppercase;
  margin: 32px 0 60px;
  p {
    font-weight: bold;
    font-size: 22px;
    line-height: 32px;
  }
  @media (max-width: ${breakpoints.xxs}) {
    padding: 12px 28px;
    p {
      font-size: 20px;
      line-height: 30px;
    }
  }
`

const ContactBlock = () => {
  const windowWidth = GetWindowWidth()
  const isDesktop = windowWidth > 600

  return (
    <ContactBlockWrap>
      {isDesktop && (
        <p>
          รับโบนัสทันที | Line:{" "}
          <a
            href={process.env.LINE_ID}
            target="_blank"
            rel="noreferrer noopener"
          >
            {process.env.LINE_ID_TEXT}
          </a>{" "}
          | hotline:{" "}
          <a
            href={`tel:${process.env.PHONE_TO_CALL}`}
            target="_blank"
            rel="noreferrer noopener"
          >
            {process.env.PHONE_TO_DISPLAY_2}
          </a>
        </p>
      )}
      {!isDesktop && (
        <p>
          รับโบนัสทันที
          <br />
          Line:{" "}
          <a
            href={process.env.LINE_ID}
            target="_blank"
            rel="noreferrer noopener"
          >
            {process.env.LINE_ID_TEXT}
          </a>
          <br />
          hotline:{" "}
          <a
            href={`tel:${process.env.PHONE_TO_CALL}`}
            target="_blank"
            rel="noreferrer noopener"
          >
            {process.env.PHONE_TO_DISPLAY_2}
          </a>
        </p>
      )}
    </ContactBlockWrap>
  )
}

export default memo(ContactBlock)
